
export {WIDGET_CLASS_NAME,
WIDGET_SELECTED_CLASS_NAME,
Widget,
WidgetHighlightStack,
WidgetResize,
WidgetResizeState,
WidgetResizer,
WidgetToolbarRepository,
WidgetTypeAround,
_WIDGET_TYPE_AROUND_SELECTION_ATTRIBUTE,
_WidgetSizeView,
_getClosestWidgetTypeAroundDomButton,
_getClosestWidgetViewElement,
_getWidgetTypeAroundButtonPosition,
_getWidgetTypeAroundFakeCaretPosition,
calculateResizeHostAncestorWidth,
calculateResizeHostPercentageWidth,
findOptimalInsertionRange,
getLabel,
isTypeAroundWidget,
isWidget,
setHighlightHandling,
setLabel,
toWidget,
toWidgetEditable,
verticalWidgetNavigationHandler,
viewToModelPositionOutsideModelElement} from '../../../frontend-editor-ckeditor-web/__liferay__/exports/@ckeditor$ckeditor5-widget$dist$index.js.js';
